import {Col, Row} from 'antd';
import React from 'react';

import BoxContent from '../../../../../../components/BoxContent/BoxContent';
import InformativeText from '../../../../../../constants/InformativeText';
import {convertPxToRem} from '../../../../../../utils/commonFunctions';
import ValueRepresentationBox from '../../../../components/ValueRepresentationBox';
import {rowGutterNZM} from '../../../../constants/commonConstants';

const FinancialWaste: React.FC<{data: any[]}> = ({data}) => {
  const wasteInfo = InformativeText?.NZM?.utility?.waste;

  return (
    <>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(239.5)}}>
        <Col span={4}>
          <ValueRepresentationBox
            data={data}
            mainKey="waste management costs"
            smallImage={true}
            isCost={true}
            tooltip={wasteInfo?.Waste_management_costs}
          />
        </Col>
        <Col span={20}>
          <BoxContent />
        </Col>
      </Row>
    </>
  );
};

export default FinancialWaste;
